module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Display ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicCursor'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Cursor\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicFloat'
      }
    }
  }, [_vm._v("\n            Float   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-display"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Display\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• Display")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_dp-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("display")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_dp-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("b")]), _vm._v(" สำหรับ \"block\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("il")]), _vm._v(" สำหรับ \"inline\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ilb")]), _vm._v(" สำหรับ \"inline-block\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("f")]), _vm._v(" สำหรับ \"flex\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("g")]), _vm._v(" สำหรับ \"grid\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("tb")]), _vm._v(" สำหรับ \"table\""), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("n")]), _vm._v(" สำหรับ \"none\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Display")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Display -->\n<div>\n  <div class=\"_dp-b\">Block</div>\n  <div class=\"_dp-b\">Block</div>\n  <div class=\"_dp-b\">Block</div>\n</div>\n\n<div>\n  <div class=\"_dp-il\">Inline</div>\n  <div class=\"_dp-il\">Inline</div>\n  <div class=\"_dp-il\">Inline</div>\n</div>\n\n<div class=\"_dp-f\">\n  <div>Flex Item</div>\n  <div>Flex Item</div>\n  <div>Flex Item</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "_mgbt-16px"
  }, [_c('div', {
    staticClass: "_dp-b _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Block")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-b _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Block")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-b _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Block")])]), _vm._v(" "), _c('div', {
    staticClass: "_mgbt-16px"
  }, [_c('div', {
    staticClass: "_dp-il _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Inline")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-il _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Inline")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-il _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Inline")])]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _mgbt-16px"
  }, [_c('div', {
    staticClass: "_dp-f _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Flex Item")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Flex Item")]), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _bgcl-neutral-200 _bdw-2px _bdcl-neutral-600"
  }, [_vm._v("Flex Item")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13d99b59","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/AtomicDisplay.vue
// module id = 112
// module chunks = 0